import { useEffect, useRef } from "react";
import { useLocation, useRoutes } from "react-router-dom";
import { RoutesConfig } from "./routes";
import { initReferralTracking } from "./utils/referral";
import { ConsentBanner } from "./components/ConsentBanner";
import { trackPageView } from "./lib/posthog";

export const App = () => {
  const element = useRoutes(RoutesConfig);
  const location = useLocation();
  const lastTrackedPath = useRef<string>();

  // Initialize referral tracking on app load
  useEffect(() => {
    initReferralTracking();
  }, []);

  useEffect(() => {
    if (lastTrackedPath.current === location.pathname) return;
    lastTrackedPath.current = location.pathname;
    trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <>
      {element}
      <ConsentBanner />
    </>
  );
};
